module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    class: _vm.customClass,
    style: (_vm.widthStyle),
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      },
      "focus": _vm.selectAll,
      "blur": _vm.formatValue
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c2801fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timechanger/TimeInput.vue
// module id = 1830
// module chunks = 1